import React from "react";

const BASE_WIDTH = 14;
const BASE_HEIGHT = 15;

export default function ComplianceWarning(props: {
  height?: number;
  width?: number;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.97396 2.62892C7.37499 2.62892 7.77388 2.88198 8.07769 3.38809L12.3039 10.4322C12.9122 11.4438 12.4426 12.2716 11.2631 12.2716H2.68485C1.50535 12.2716 1.03569 11.443 1.64403 10.4322L5.87023 3.38809C6.17404 2.88198 6.57293 2.62892 6.97396 2.62892ZM6.97396 1.19922C6.04752 1.19922 5.1997 1.72821 4.64426 2.65108L0.418061 9.69666C-0.143812 10.6324 -0.205289 11.6303 0.250071 12.4345C0.705432 13.2387 1.59328 13.7013 2.68485 13.7013H11.2631C12.3546 13.7013 13.2432 13.2395 13.6979 12.4353C14.1525 11.631 14.0917 10.6331 13.5299 9.69737L9.30366 2.65323C8.74822 1.72821 7.90041 1.19922 6.97396 1.19922Z"
        fill="#FFB41F"
      />
      <path
        d="M6.97392 11.2326C7.48717 11.2326 7.90323 10.8166 7.90323 10.3033C7.90323 9.79009 7.48717 9.37402 6.97392 9.37402C6.46068 9.37402 6.04462 9.79009 6.04462 10.3033C6.04462 10.8166 6.46068 11.2326 6.97392 11.2326Z"
        fill="#FFB41F"
      />
      <path
        d="M8.04631 6.01368C8.04631 5.42036 7.56664 4.94141 6.97403 4.94141C6.79852 4.94144 6.62571 4.98458 6.47077 5.06703C6.31584 5.14949 6.18353 5.26874 6.08548 5.4143C5.98743 5.55987 5.92663 5.72729 5.90843 5.90185C5.89023 6.07641 5.91518 6.25277 5.9811 6.41543C6.37713 7.39907 6.97403 8.87309 6.97403 8.87309L7.96839 6.41543C8.017 6.29176 8.04631 6.15594 8.04631 6.01368Z"
        fill="#FFB41F"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
